<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="create_activitytype" ttGoto="activitytype" [ttGotoParms]="{ activitytype_no: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListActivityTypes"></tt-list>
</tt-page>
